import { render, staticRenderFns } from "./StoryView.vue?vue&type=template&id=591023c0&scoped=true&"
import script from "./StoryView.vue?vue&type=script&lang=js&"
export * from "./StoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591023c0",
  null
  
)

export default component.exports